import { useMemo } from 'react'
import useInitials from 'tennders-common/hooks/useInitials'

const useCountries = () => {
  const { loading, countries } = useInitials()

  const newCountries = useMemo(() => countries.map(
    (country) => ({ label: country.name, value: country.code })
  ), [countries])

  const supportedCounties = useMemo<string[]>(() => countries
    .filter((country) => country.isSupported)
    .map((country) => country.code), [countries])

  return {
    countries: newCountries,
    loading,
    supportedCounties
  }
}

export default useCountries
